<template>
  <AvailableProducts />
</template>

<script>
import AvailableProducts from '@/components/AvailableProducts'

export default {
  components: {
    AvailableProducts,
  },
}
</script>
